import React from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import checkmark from '../../../assets/checkmark.png';

export const ReopenTicketSuccessPopup = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleGotIt} open={props.open}>
      <Box className={classes.root}>
        
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>{(props.screen == 'support') ? 'Ticket Reopened' : 'MLW Data Deletion Successfull'}</Typography>
        </Box>
        
        <Box className={classes.cardBodyContainer}>
          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
            <Box className={classes.imageContainer}>
                <img className={classes.checkImg} src={checkmark} alt='img' /> 
                <span className={classes.request}>{(props.screen == 'support') ? `Your ticket ${props?.supportTicketDetails?.supportRequestNumber} is reopened successfully.` : 'Your data privacy request is submitted successfully.'}</span>                
            </Box> 
            {(props.screen == 'support') && <Typography className={classes.paragraph}>Your inquiry may take up to 5 business days to get responded.</Typography> }
            {(props.screen !== 'support') && <>
             <Typography className={classes.paragraph}>MLW data associated with Loan Number: {props?.loanNumber} has been successfully deleted.</Typography>
             <Typography className={classes.paragraph}>Please note that this action only removes data stored within MLW.</Typography>
             <Typography className={classes.paragraph}>If related data exists in other systems or repositories outside MLW, it must be reviewed and handled separately  per the CCPA process.</Typography> 
             <Typography className={classes.paragraph}>This action has been logged for audit purposes.</Typography> 
             </>}
            </Box> 
          </Box>
        </Box>

        <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={props.handleGotIt}
            >Got it</Button>
        </Box>
      </Box> 
    </Dialog>
  )
}
